import React, { FC, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { getSelectedPage } from '@/actions/actions'
import { PageContent } from '@/components/PageContent/PageContent'
import useStore from '@/store/useStore'

export const Selected: FC = () => {
  const { search } = useLocation()
  const setPage = useStore((state) => state.page.setPage)

  useEffect(() => {
    const controller = new AbortController()
    void getSelectedPage(controller.signal, search)
    return () => {
      setPage(null)
      controller.abort()
    }
  }, [])

  return <PageContent isSectionTitleHidden={true} />
}
